import React from 'react';
import { findDOMNode } from 'react-dom';
import {
  Button, Spin, Modal, List, Card, Icon, Radio, Pagination, Input, Row
} from 'antd';
import { inject, observer } from 'mobx-react';
import LazyLoad from 'react-lazy-load';
import { toJS } from 'mobx';
import Tags from './Tags';
import base from '../../tool/base';
import { findReadme } from '../../api/list';
import Comments from './Comments';
import Navigation from '../public/navigation';
import FormList from './FormList';
import ItemInfo from './ItemInfo';
import SingleEcodeWf from '../main/SingleEcodeWf';
import { isEmpty } from 'lodash';
import EcodeLocal from '../ecodeLocal';
import WorkflowDetail from './_detail';
import util from '../../util';

const {
  getAccessToken
} = util;

const store = [
  'listStore',
  'workflowStore',
  'homeStore',
]

@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      line: true,
      visible: false,
    }
  }

  componentDidMount() {
    const { 
      workflowStore: { getCaseList, params: caseParams, getTagsList, getHotList, getCommentList, scrollTop, setState, tagsSearch, searchFormValue, backStatus, caseList },
      location: { query },
      listStore: { setSearchValue },
    } = this.props;
    const { type } = query;
    setSearchValue(toJS(searchFormValue.title));
    (type === 'workflowStyle' || type === 'workflowChart') && setState({tagsSearch: {...tagsSearch, demotype: type}});
    getCaseList({
      ...toJS(caseParams),
    }, !(caseList && caseList.length > 0));
    document.documentElement.scrollTo({top: scrollTop});
    getTagsList();
    getHotList({
      pageNum: 1,
      pageSize: 10,
    });
    getCommentList({
      pageNum: 1,
      pageSize: 10,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { workflowStore: { getHotList, getCaseList, setState, tagsSearch } } = this.props;
    if(nextProps.location.query.type !== this.props.location.query.type) {
      setState({tagsSearch: {...tagsSearch, demotype: nextProps.location.query.type}});
      getHotList();
      getCaseList();
    } 
  }

  onPageChange = (pageNum, pageSize) => {
    const { workflowStore: { setState, getCaseList } } = this.props;
    setState({params: {pageNum, pageSize}});
    getCaseList({
      pageNum,
      pageSize,
    });
  }

  sort = e => {
    const { workflowStore: { setSearchValue, getCaseList } } = this.props;
    setSearchValue({orderby: e.target.value});
    getCaseList();
  }

  getHotDownload = e => {
    const { workflowStore: { setState, getHotList } } = this.props;
    setState({downloadTag: e.target.value});
    getHotList({
      pageNum: 1,
      pageSize: 10,
    });
  }

  searchValueChange = e => {
    const { workflowStore: {setSearchValue} } = this.props;
    setSearchValue({title: e.target.value});
  }

  onSearch = () => {
    const { workflowStore: { getCaseList, searchFormValue, initPage }, listStore: { setMobxState, params } } = this.props;
    initPage();
    setMobxState({
      params: {
        ...params,
        searchValue: toJS(searchFormValue.title),
      }
    })
    getCaseList();
  }

  onNavClick = (item) => {
    const { workflowStore: { routing }, location: { query }, homeStore: { type } } = this.props;
    if (item.key === '1') routing.push({
      pathname: '/',
      query,
    });
  }

  collection = appId => {
    const { workflowStore: { setStars, getCaseList, starsLoading } } = this.props;
    !starsLoading && setStars({appId}).then(data => data.msg !== '未登录' && getCaseList({}, false));;
  }

  download = (id, folderId) => {
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { workflowStore: { getCaseList} } = this.props;
    base.callApi('/v5/ecode/downloadCount', 'POST', {appId: folderId}, 'json', 'text').then((data) => {
      if (data.status) {
        window.open(url);
        getCaseList();
      } else {
        console.error("后端接口异常，请联系管理员！");
      }
    });
  }

  details = (folderId, demoId) => {
    const { workflowStore: { routing, setState }, location: { query } } = this.props;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const { detailModal } = query;
    if(detailModal === 'true') {
      this.openDetailModal(folderId, demoId);
      return;
    }
    setState({scrollTop});
    routing.push({
      pathname: `/app/workflowDetail/${folderId}`,
      query: {
        ...query,
        demoId,
      }
    });
  }

  getDetailInfo = (appId, demoId) => {
    const { workflowStore: { getCommentList, getHotList, getDetail, findReadme, setDetailParams } } = this.props;
    setDetailParams({
      demoId,
      appId,
    })
    findReadme(appId);
    getDetail({demoId, appId}, true);
    getCommentList({appId});
    getHotList();
  }

  renderTags = (list, value, onChange, newClassName) => {
    return (
      <div className={`workflow-page-content-sort ${newClassName}`}>
        <Radio.Group value={value} onChange={onChange}>
          {list && list.length > 0 && list.map(listItem => 
              <Radio.Button key={listItem.value} value={listItem.value}>{listItem.label}</Radio.Button>
          )}
        </Radio.Group>
      </div>
    );
  }

  onCancel = () => {
    const { workflowStore: { initDetailParams, setState } } = this.props;
    this.setState({visible: false});
    setState({workflowDetail: []})
    initDetailParams();
  }

  openDetailModal = (appId, demoId) => {
    this.setState({visible: true});
    this.getDetailInfo(appId, demoId);
  }

  renderWorkflowGrid	= () => {
    const {
      workflowStore: { loading, caseList, loadMore, params, count, line, getCaseList }
    } = this.props;
    const tileContent = (
      caseList && caseList.length > 0 ? caseList.map((list) => {
        return (
          <SingleEcodeWf
            num={3}
            data={list}
            key={list.id}
            onDownload={this.download}
            onStars={this.collection}
            details={this.details}
            onChange={() => getCaseList({}, false)}
          />
        )
      })
      : <div className="ant-list-empty-text">
          <div style={{minHeight: 400, paddingTop: 120}}>
            <div className="icon-Cloud-No-data" />
            <p style={{ textAlign: 'center' }}>暂无数据</p>
          </div>
        </div>
    );
    return (
      <div className="workflow-page-list">
        <Spin spinning={loading}>
          {
            line ?
            <List
              ref={c => this.caseList = c}
              grid={{ gutter: 16, column: 1 }}
              dataSource={caseList}
              locale={{
                emptyText: (
                  <div style={{minHeight: 400, paddingTop: 120}}>
                    <div className="icon-Cloud-No-data" />
                    <p style={{ textAlign: 'center' }}>暂无数据</p>
                  </div>
                )
              }}
              renderItem={item => (
                <List.Item>
                  <Card
                    style={{ width: '100%' }} 
                    className="workflow-page-list-card"
                  >
                    <LazyLoad className="workflow-page-list-lazy-load">
                      <div onClick={() => this.details(item.folderId, item.id)}>
                        <img className="workflow-page-list-image" src={item.imageList && item.imageList[0].imageLink} alt='' />
                      </div>
                    </LazyLoad>
                    <div className="workflow-page-list-card-content">
                      <List.Item.Meta
                        className="workflow-page-list-meta"
                        title={<div className="workflow-page-list-meta-span workflow-title" title={item.title}>{item.title}</div>}
                        description={<div className="workflow-page-list-meta-span workflow-description" title={item.description || item.title}>{item.description || item.title}</div>}
                      />
                      <ItemInfo item={item} className="show-list" >
                        <div className="workflow-info-box">
                          <span className="workflow-info-box-item workflow-tags">行业：
                            {
                              item.genreList && item.genreList.map((genre) => 
                                <span key={genre.g_id} className="workflow-info-box-light workflow-tag">{genre.g_name}</span>
                              )
                            }
                          </span>
                          <span className="workflow-info-box-item workflow-tags">职能：
                            {
                              item.functionList && item.functionList.map((func) => 
                                <span key={func.g_id} className="workflow-info-box-light workflow-tag">{func.g_name}</span>
                              )
                            }
                          </span>
                        </div>
                      </ItemInfo>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
            : <Row className={`${caseList && caseList.length > 0 ? 'workflow-page-list-tile' : ''}`}>{tileContent}</Row>
          }
          {
            caseList && caseList.length > 0 && 
              <Pagination
                className="workflow-page-list-pagination"
                current={params.pageNum}
                pageSize={params.pageSize}
                total={count}
                showSizeChanger
                showQuickJumper
                pageSizeOptions={['12', '24', '36', '48']}
                onChange={this.onPageChange}
                onShowSizeChange={this.onPageChange}
              />
          }
        </Spin>
      </div>
    );
  }
  render() {
    const { visible } = this.state;
    const {
      workflowStore: { setState, params, searchFormValue, downloadTag, downloadList, newComment, count, line }, listStore: { sreenDatas },
    } = this.props;
    const sortList = [{
      label:  <span>
                最新
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'createdate',
    }, {
      label:  <span>
                最热
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'downloadcounts',
    }, {
      label:  <span>
                访问量
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'visits',
    }];
    const downloadTags = [{
      label: '累计',
      value: 'total',
    }, {
      label: '本月',
      value: 'month',
    }, {
      label: '本年',
      value: 'year',
    }];
    const navs = [
      { key: '1', breadcrumbName: '云商店', path: '/' },
      { key: '2', breadcrumbName: '流程表单', path: '/app/workflow' },
      // { key: '3', breadcrumbName: '详情', path: '/' },
    ];
    return (
      <div className='workflow-page'>
        <div className='workflow-page-top'>
          <Navigation datas={navs} onClick={this.onNavClick} />
          <div className="workflow-page-import" >
            {/* <EcodeLocal
              demoType="workflowChart"
              title="导入流程案例"
            /> */}
          </div>
        </div>
        <Tags onChange={value => setState({tagsSearch: value, params: {...params, pageNum: 1} })} />
        <div className='workflow-page-content'>
          <div className='workflow-page-content-left'>
            <div className='workflow-page-content-left-box'>
              <div className='workflow-page-content-header'>
                <h3>流程表单列表</h3>
                <div className='workflow-page-content-header-info'>
                  <span>共有<span className="workflow-numbre">{count}</span>个表单</span>
                  <div className="workflow-icons">
                    <div className='list-style-div' onClick={() => setState({line: true})}>
                      <div className={`icon-Cloud-List list-style-icon ${line && 'list-style-icon-active'}`} />
                    </div>
                    <div className='list-style-div' onClick={() => setState({line: false})}>
                      <div className={`icon-Cloud-Tile list-style-icon ${!line && 'list-style-icon-active'}`} />
                    </div>
                  </div>
                </div>
              </div>
              {this.renderTags(sortList, searchFormValue.orderby, this.sort, 'list-sort-up')}
              {this.renderWorkflowGrid()}
            </div>
          </div>
          <div className='workflow-page-content-right'>
            <div className='workflow-page-content-search'>
              <Input  className='workflow-page-content-search-input' value={searchFormValue.title} onChange={this.searchValueChange} onPressEnter={this.onSearch} />
              <Icon type="search" className='workflow-page-content-search-icon' onClick={this.onSearch} />
            </div>
            <div className='workflow-page-content-item'>
              <div className='workflow-page-content-item-header'>
                {/* <Icon type="fire" theme="filled" className='workflow-page-content-item-header-icon'/> */}
                <svg className="icon-font workflow-page-content-item-header-icon" aria-hidden="true">
                  <use href="#icon-fire"></use>
                </svg>
                <h3>热门下载</h3>
              </div>
              {this.renderTags(downloadTags, downloadTag, this.getHotDownload)}
              <FormList datas={downloadList} otherColor onClick={(value) => this.details(value.folderId, value.id)} />
            </div>
            <div className='workflow-page-content-item'>
              <div className='workflow-page-content-item-header'>
                {/* <Icon type="fire" theme="filled" className='workflow-page-content-item-header-icon'/> */}
                <svg className="icon-font workflow-page-content-item-header-icon" style={{color: '#449AF8'}} aria-hidden="true">
                  <use href="#icon-comments"></use>
                </svg>
                <h3>最新评论</h3>
              </div>
              <div className='workflow-page-content-item-comment'>
                <Comments
                  datas={newComment}
                  userNew
                  onClick={value => this.details(value.appId, value.demoId)}
                />
              </div>
            </div>
          </div>
        </div>
        <WorkflowDetail
          visible={visible}
          onCancel={this.onCancel}
        />
      </div>
    );
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/workflow/index.js